import React from 'react'

export default function PoliticasView() {
  return (
    <div className='container py-5'>
        <div className='bold f-22 text-center pb-5'>Política de privacidad de la webapp BienVivir</div>
        <div className='bold'>Introducción</div>
        <br></br>
        <div>La webapp “BienVivir”, respeta la privacidad de sus usuarios. Esta política de privacidad explica cómo recopilamos, utilizamos, compartimos y protegemos la información personal de los usuarios de nuestra app.</div>
        <br></br>
        <div  className='bold'>Información que recopilamos</div>
        <br></br>
        <div>Recopilamos dos tipos de información de los usuarios de nuestra app:</div>
        <br></br>
        <div>
            <ul>
                <li>nformación que los usuarios proporcionan: Recopilamos información que los usuarios proporcionan voluntariamente al crear una cuenta o al utilizar nuestra app. Esta información puede incluir el nombre, la dirección de correo electrónico, la fecha de nacimiento, el género, la ubicación y la información de contacto.</li>
                <li>Información que se recopila automáticamente: Recopilamos información automáticamente cuando los usuarios utilizan nuestra app. Esta información puede incluir el historial de navegación, la ubicación del dispositivo, los datos de uso de la app y la información de los dispositivos.</li>
            </ul>
        </div>
        <br></br>
        <div  className='bold'>Cómo utilizamos la información</div>
        <br></br>
        <div>Utilizamos la información que recopilamos para los siguientes fines:</div>
        <br></br>
        <div>
            <ul>
                <li>Para proporcionar y mejorar nuestra app: Utilizamos la información para proporcionar y mejorar nuestra app. Por ejemplo, utilizamos la información para personalizar el contenido y los anuncios, para detectar y prevenir el fraude y para mejorar la seguridad de nuestra app.</li>
                <li>Para comunicarnos con los usuarios: Utilizamos la información para comunicarnos con los usuarios sobre nuestra app, nuestros productos y servicios y otras ofertas que pueden ser de su interés.</li>
                <li>Para fines de marketing: Utilizamos la información para mostrar a los usuarios anuncios relevantes.</li>
            </ul>
        </div>
        <div  className='bold'>Quién tiene acceso a la información</div>
        <br></br>
        <div>Solo los empleados autorizados de "BienVivir" tienen acceso a la información personal de los usuarios. También compartimos la información personal de los usuarios con terceros para los siguientes fines:</div>
        <br></br>
        <div>
            <ul>
                <li>Para proporcionar servicios a nombre de "BienVivir": Por ejemplo, utilizamos proveedores de servicios externos para alojar nuestra app, procesar pagos y enviar correos electrónicos.</li>
                <li>Para cumplir con la ley: Compartimos la información personal de los usuarios con las autoridades gubernamentales cuando sea necesario para cumplir con la ley.</li>
            
            </ul>
        </div>
        <br></br>
        <div  className='bold'>Cómo protegemos la información</div>
        <br></br>
        <div>Utilizamos medidas de seguridad físicas, electrónicas y administrativas para proteger la información personal de los usuarios.</div>
        <br></br>
        <div  className='bold'>Sus derechos</div>
        <br></br>
        <div>Los usuarios tienen los siguientes derechos en relación con su información personal:</div>
        <br></br>
        <div>
            <ul>
                <li>Acceso: Los usuarios tienen derecho a acceder a su información personal.</li>
                <li>Corrección: Los usuarios tienen derecho a corregir su información personal si es inexacta.</li>
                <li>Eliminación: Los usuarios tienen derecho a eliminar su información personal en determinadas circunstancias.</li>
                <li>Oposición: Los usuarios tienen derecho a oponerse al tratamiento de su información personal en determinadas circunstancias.</li>
            
            </ul>
        </div>
        <br></br>
        <div  className='bold'>Cómo ponerse en contacto con nosotros</div>
        <br></br>
        <div>Si tiene alguna pregunta o inquietud sobre nuestra política de privacidad, puede ponerse en contacto con nosotros en:</div>
        <br></br>
        <div>
            <ul>
                <li>Correo electrónico: administracion@bienvivir.com</li>
            
            </ul>
        </div>
        <br></br>
        <div className='bold'>Cambios en la política de privacidad</div>
        <br></br>
        <div>Podemos actualizar esta política de privacidad de vez en cuando. Si realizamos cambios importantes en la política de privacidad, le notificaremos por correo electrónico o mediante un aviso en nuestra app.</div>
        <div className='py-5'><a href="assets/politicas.pdf" download>Descargar PDF</a></div>
    </div>
  )
}
